import { transformDateToLocalDateString, useTranslate } from "helpers";
import { VehicleSpecificationProps } from "../types";

const VehicleInsurance: React.FC<VehicleSpecificationProps> = ({ fleetVehicleDetail }) => {
    const { t } = useTranslate();

    return (
        <div className="border-b border-slate-200 px-4 flex gap-3">
            <div className="flex-1 pt-4">
                <div className="text-sm font-bold text-slate-600 mb-3">
                    {t("admin.fleet.vehicle.detail.info.autoinsurance")}
                </div>
                <div className="grid grid-cols-2 gap-3 mb-4">
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.autoinsurancecontact")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {fleetVehicleDetail.autoInsuranceContact?.name ?? ""}
                        </div>
                    </div>
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.autoinsuranceexpirydate")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {transformDateToLocalDateString(fleetVehicleDetail.autoInsuranceExpiryDate)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-px bg-slate-200" />
            <div className="flex-1 pt-4">
                <div className="text-sm font-bold text-slate-600 mb-3">
                    {t("admin.fleet.vehicle.detail.info.casco")}
                </div>
                <div className="grid grid-cols-2 gap-3 mb-4">
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.cascocontact")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {fleetVehicleDetail.cascoContact?.name ?? ""}
                        </div>
                    </div>
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.cascoexpirydate")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {transformDateToLocalDateString(fleetVehicleDetail.cascoExpiryDate)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleInsurance;
